import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import {
  getNoticeDetail,
  getNoticePrevNext,
} from '../../modules/NetworkFunction';
import AuthContext from '../../contexts/AuthContext';
import styled from 'styled-components';

function NoticeContent({ history }) {
  const { auth: token } = useContext(AuthContext);
  const { noticeNo } = useParams();

  const [pnData, setPnData] = useState([]);
  const [isPnLoaded, setIsPnLoaded] = useState(false);
  const [noticeDetail, setNoticeDetail] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (!isDataLoaded) {
      const Param = { noticeNo };

      getNoticeDetail(Param, setNoticeDetail, setIsDataLoaded, () => {}, token);
    }
  }, [isDataLoaded, noticeNo, token]);

  useEffect(() => {
    if (!isPnLoaded) {
      const reqParam = { noticeNo };
      getNoticePrevNext(
        reqParam,
        setPnData,
        setIsPnLoaded,
        (e) => {
          console.log(e);
        },
        token
      );
    }
  }, [isPnLoaded, noticeNo, token]);

  const Push = (noticeNo) => {
    history.replace({
      pathname: '/mypage/notice-content',
      state: noticeNo,
    });
    setIsDataLoaded(false);
    setIsPnLoaded(false);
  };

  return (
    <div>
      <p style={{ fontSize: 30, marginBottom: 16, paddingTop: 20 }}>공지사항</p>
      <Line />
      <div
        style={{
          paddingTop: 15,
          paddingBottom: 15,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <div
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}
        >
          <p style={{ marginRight: 140 }}>제목</p>
          <p>{noticeDetail.title}</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <p style={{ marginRight: 123 }}>작성일</p>
          {noticeDetail.createDate && (
            <p style={{ marginRight: 150 }}>
              {moment(noticeDetail.createDate).format('YYYY-MM-DD HH:mm:ss')}
            </p>
          )}
          <p style={{ marginRight: 20 }}>NO.</p>
          <p>{noticeDetail.noticeNo}</p>
        </div>
      </div>
      <Line />
      <div
        style={{
          paddingTop: 30,
          paddingLeft: 20,
          paddingBottom: 10,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <p>{noticeDetail.contents}</p>
        </div>
        <button
          style={{
            borderRadius: 5,
            border: '1px solid #b5b5b5',
            width: 90,
            height: 37,
            backgroundColor: 'white',
            color: '#b5b5b5',
            alignSelf: 'flex-end',
            cursor: 'pointer',
            marginBottom: 15,
            fontSize: 16,
          }}
          onClick={() => {
            history.goBack();
          }}
        >
          목록
        </button>
      </div>

      {pnData.prev && (
        <>
          <Line />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '8px 20px',
              color: '#848484',
            }}
          >
            <img
              src="/icons/ic-prev-nc.png"
              alt="이전글"
              style={{
                marginRight: 10,
                cursor: 'pointer',
              }}
              onClick={() => Push(pnData.prev.noticeNo)}
            />
            <p
              style={{ marginRight: 108, cursor: 'pointer' }}
              onClick={() => Push(pnData.prev.noticeNo)}
            >
              이전글
            </p>
            <p
              style={{ cursor: 'pointer' }}
              onClick={() => Push(pnData.prev.noticeNo)}
            >
              {pnData.prev.title}
            </p>
          </div>
        </>
      )}
      <Line />
      {pnData.next && (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '8px 20px',
              color: '#848484',
            }}
          >
            <img
              src="/icons/ic-next-nc.png"
              alt="다음글"
              style={{
                marginRight: 10,
                cursor: 'pointer',
              }}
              onClick={() => Push(pnData.next.noticeNo)}
            />
            <p
              style={{ marginRight: 108, cursor: 'pointer' }}
              onClick={() => Push(pnData.next.noticeNo)}
            >
              다음글
            </p>
            <p
              style={{ cursor: 'pointer' }}
              onClick={() => Push(pnData.next.noticeNo)}
            >
              {pnData.next.title}
            </p>
          </div>
          <Line />
        </>
      )}
    </div>
  );
}

export default NoticeContent;

const Line = styled.hr`
  background-color: #848484;
  height: 0.2px;
  border: 0;
`;
